module.exports = __webpack_public_path__ + "static/img/w03.137035e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/akvarium-uveg/w03.jpg
// module id = 537
// module chunks = 0